/**
 * Invited staff need a real personal name (not email) so Team / activity
 * lists show who did the work, plus they choose a Team Member Pin on signup
 * (overwriting any provisional auto-assigned PIN).
 */

import { hasStaffPinUserSet } from "./staffPin";

export function isInvitedStaffUser(user) {
  if (!user) return false;
  // Only prompted for invitees — not the original account owner/admins.
  if (user.invitedStaff) return true;
  if (user.staffAccess?.mode === "custom") return true;
  return false;
}

export function hasUsableStaffName(user) {
  const name = String(user?.displayName || "").trim();
  if (!name) return false;
  const email = String(user?.email || "").trim().toLowerCase();
  if (email && name.toLowerCase() === email) return false;
  if (name.includes("@")) return false;
  // Require at least a first + last name so Team lists stay readable.
  const parts = name.split(/\s+/).filter(Boolean);
  return parts.length >= 2 && parts.every((p) => p.length >= 1);
}

export function needsStaffNamePrompt(user) {
  return isInvitedStaffUser(user) && !hasUsableStaffName(user);
}

/** First-login gate: name and/or user-chosen PIN still missing. */
export function needsStaffSetupPrompt(user) {
  if (!isInvitedStaffUser(user)) return false;
  return !hasUsableStaffName(user) || !hasStaffPinUserSet(user);
}
